/* eslint-disable no-nested-ternary */
/* eslint-disable no-bitwise */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { HistoricalIvr, IvrState } from "./IvrHud";
import ai1025 from '../icons/ai1025.png'
import ai1027 from '../icons/ai1027.png'
import ai1026 from '../icons/ai1026.png'
import ai1028 from '../icons/ai1028.png'
import AIR_IMG from '../icons/AIR.png'

import { Delta } from "../QueueLeaderboard";
import { IvrMetric } from "./IvrWidgetContainer";
import defaultIvrImg from '../icons/default-ivr-image.png'

const DonutSmall = ({ mode, transferred, abandoned, other, isAir }: { mode: string; transferred: number; abandoned: number; other: number, isAir: boolean}) => {
  const total = transferred + abandoned + other;

  const transferredPercentage = total === 0 ? 0 : (transferred / total) * 360;
  const abandonedPercentage = total === 0 ? 0 : (abandoned / total) * 360;
  const otherPercentage = total === 0 ? 0 : (other / total) * 360;
  return (
    <div
      className="ex-queue-call-data-donut"
      style={{
        height: 75,
        minHeight: 75,
        maxHeight: 75,
        minWidth: 75,
        maxWidth: 75,
        width: 75,
        position: "relative",
        fontSize: 16,
        paddingRight: 15,
        paddingTop: 25,
        display: "inline-block",
      }}
    >
      <div
        className="widget-call-chart"
        style={{
          borderRadius: 50,
          background: 
          isAir ?
            (transferredPercentage + abandonedPercentage + otherPercentage) === 0 ? "#8ba28b57" : `conic-gradient(

            green 0deg ${abandonedPercentage}deg,
            brown ${abandonedPercentage}deg ${transferredPercentage + abandonedPercentage}deg,
            purple ${transferredPercentage + abandonedPercentage}deg ${transferredPercentage + abandonedPercentage + otherPercentage}deg

            )` : 
            (transferredPercentage + abandonedPercentage + otherPercentage) === 0 ? "#8ba28b57" : `conic-gradient(

            green 0deg ${transferredPercentage}deg,
            brown ${transferredPercentage}deg ${transferredPercentage + abandonedPercentage}deg,
            purple ${transferredPercentage + abandonedPercentage }deg ${transferredPercentage + abandonedPercentage + otherPercentage}deg

            )`,
        }}>
        <div
          className="widget-call-overlay"
          style={{
            background: mode === "light" ? "#f5f5f5" : "#0e0e0e",
          }}
        >
          <h5 style={{ marginBottom: 0, marginTop: 0, fontSize: 20 }}>
            {transferred + abandoned + other}
          </h5>
          <span style={{ fontWeight: "bold", fontSize: 14 }}>
            Calls
          </span>
        </div>
      </div>
    </div>

  )
}
interface IProps {
   ivr: HistoricalIvr;
   accessToken: string | undefined;
   mode: string;
   ivrMetric: IvrMetric;
   delta: Delta | undefined;
}
const defaultMetric = {
  abandoned: {
    weight: 0,
    duration: 0
  },
  other: {
    weight: 0,
    duration: 0
  },
  transferred: {
    weight: 0,
    duration: 0
  },
  talking: []
}

const IvrWidget = React.memo(({mode, ivr, accessToken, ivrMetric, delta}: IProps) => {
    const {name, isAir, extensionNumber, site, uri, id } = ivr;
    const {abandoned, other, transferred, talking} = ivrMetric || {...defaultMetric};
    const [longestWait, setLongestWait] = useState("- : - : -");
    const talkingArray = useMemo(() => Array.from(talking.values()), [ivrMetric]);
     useEffect(() => {
        if (talkingArray.length === 0) {
          setLongestWait("- : - : -");
          return;
        }
        const calculateLongestWait = () => {
          const now = Date.now();
          const longestWaitTime = Math.max(
            ...talkingArray.map((call) => now - new Date(call.timeStamp).getTime())
          );
    
          const seconds = Math.floor((longestWaitTime / 1000) % 60);
          const minutes = Math.floor((longestWaitTime / (1000 * 60)) % 60);
          const hours = Math.floor(longestWaitTime / (1000 * 60 * 60));
    
          setLongestWait(
            `${hours.toString().padStart(2, "0")}:${minutes
              .toString()
              .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
          );
        };
        calculateLongestWait();
        const interval = setInterval(calculateLongestWait, 1000);
    
        // Cleanup interval on unmount or when waiting becomes empty
        // eslint-disable-next-line consistent-return
        return () => clearInterval(interval);
      }, [ivrMetric]);


    const getImg = (ext: string, air: boolean) => {
       if (air) {
        if (ext === "1025") return ai1025;
        if (ext === "1026") return ai1026;
        if (ext === "1027") return ai1027;
        if (ext === "1028") return ai1028;
        return "./default-user-image.ico"
       } 
       return defaultIvrImg
    }
    
      const calculateAverage = useCallback((_duration: number, _count: number) => {
        if(_count === 0) {
          return "--:--";
        } 
        const duration = _duration / _count;
        const seconds = Math.floor((duration / 1000) % 60);
        const minutes = Math.floor((duration / (1000 *60)));
        const outNumber = seconds === 0 && minutes === 0 ? "--:--" : `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        return outNumber.startsWith('0') ? outNumber.slice(1) : outNumber;
      }, []);
      
    return (
        <div className={`ivr-grid-item ${mode === 'light' ? "ivr-light" : 'ivr-dark'} ${isAir ? "air" : ""}`}>
          <div className="ivr-header">
            <div className="ivr-header-left">
            <h3 className="ivr-title notranslate">{name}</h3>
            <h3 className="ivr-title notranslate">{extensionNumber}</h3>
            </div>
            <div className="ivr-header-right">
              {isAir && <div className="notranslate" >
                <img style={{height: 28, width: 28, filter: mode === "light" ? "invert(0.3)" : "invert(1)"}} src={AIR_IMG} alt='air-logo'/></div>}
            </div>
          </div>
          <div className={`ivr-body-banner ${talkingArray && talkingArray.length ? "active" : "idle"} ${mode === 'light' ? "light" : "dark"}`}>
            <div className="ivr-img-container">
            <img className={`ivr-profile ${ivrMetric && ivrMetric.talking && talkingArray.length ? "active" : ""}`} src={getImg(extensionNumber, ivr.isAir)} alt="IVR" />
            {!ivr.isAir && <h3 className="ivr-title notranslate">{ivr.extensionNumber}</h3>}
            </div>
            <div className="ivr-banner-content">
              <span>Engaged: {talkingArray.length || 0}</span>
            <span>Longest: {longestWait}</span>
            </div>
          </div>
          <div className="ivr-lower-content">
            <div className="ivr-call-donut">             
              <DonutSmall transferred={transferred.weight} abandoned={abandoned.weight} other={other.weight} mode={mode} isAir={isAir} />
            </div>
            <div className="widget-footer-right">
          <div className="widget-chart-header">

            <div className="widget-chart-header-text title-text">Result</div>
            <div className="widget-chart-header-text title-text">Total</div>
            <div className="widget-chart-header-text title-text">%</div>
            <div className="widget-chart-header-text title-text">Avg. Dur</div>
            
            {
              isAir && (
                <>
                  <div className="widget-chart-header-text"><span className="widget-body-detail-indicator transferred" />Ended</div>
                  <div className="widget-chart-header-text">{abandoned.weight}</div>
                  <div className="widget-chart-header-text">{abandoned.weight ? `${Math.floor(abandoned.weight / ((abandoned.weight + other.weight + transferred.weight) || 1) * 100)}%` : "--"}</div>
                  <div className="widget-chart-header-text">{calculateAverage(abandoned.duration, abandoned.weight)}</div>

                  <div className="widget-chart-header-text"><span className="widget-body-detail-indicator abandoned" />Transferred</div>
                  <div className="widget-chart-header-text">{transferred.weight}</div>
                  <div className="widget-chart-header-text">{transferred.weight ? `${Math.floor(transferred.weight / ((abandoned.weight + other.weight + transferred.weight) || 1) * 100)}%`: "--"}</div>
                  <div className="widget-chart-header-text">{calculateAverage(transferred.duration, transferred.weight)}</div>
                </>
              )
            }
            {
              !isAir && (
                <>
                  <div className="widget-chart-header-text"><span className="widget-body-detail-indicator transferred" />Transferred</div>
                  <div className="widget-chart-header-text">{transferred.weight}</div>
                  <div className="widget-chart-header-text">{transferred.weight ? `${Math.floor(transferred.weight / ((abandoned.weight + other.weight + transferred.weight) || 1) * 100)}%`: "--"}</div>
                  <div className="widget-chart-header-text">{calculateAverage(transferred.duration, transferred.weight)}</div>

                  <div className="widget-chart-header-text"><span className="widget-body-detail-indicator abandoned" />Abandoned</div>
                  <div className="widget-chart-header-text">{abandoned.weight}</div>
                  <div className="widget-chart-header-text">{abandoned.weight ? `${Math.floor(abandoned.weight / ((abandoned.weight + other.weight + transferred.weight) || 1) * 100)}%` : "--"}</div>
                  <div className="widget-chart-header-text">{calculateAverage(abandoned.duration, abandoned.weight)}</div>
                </>
              )
            }

            <div className="widget-chart-header-text"><span className="widget-body-detail-indicator other" />Other</div>
            <div className="widget-chart-header-text">{other.weight}</div>
            <div className="widget-chart-header-text">{other.weight ? `${Math.floor(other.weight / ((abandoned.weight + other.weight + transferred.weight) || 1) * 100)}%` : "--"}</div>
            <div className="widget-chart-header-text">{calculateAverage(other.duration, other.weight)}</div>
            
          </div>
        </div>
          </div>
        </div>
    );
});

export default IvrWidget;